'use strict';

const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_navigation_PageNavigation_NestedThirdRow = require('./NestedThirdRow.cjs.js');
const components_navigation_PageNavigation_PageNavigationBadge = require('./PageNavigationBadge.cjs.js');
const components_navigation_PageNavigation_PageNavigationRow = require('./PageNavigationRow.cjs.js');
const components_navigation_PageNavigation_utils_checkIsTruncated = require('./utils/checkIsTruncated.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const list = "_list_pvui1_1";
const textEllipsis = "_text-ellipsis_pvui1_7";
const textWrap = "_text-wrap_pvui1_14";
const rowContainer = "_row-container_pvui1_21";
const styles = {
	list: list,
	textEllipsis: textEllipsis,
	textWrap: textWrap,
	rowContainer: rowContainer
};

function NestedSecondRow({ item, onSelect }) {
  const [isTruncated, setIsTruncated] = React.useState(false);
  const textRef = React.useRef(null);
  React.useEffect(() => {
    setIsTruncated(components_navigation_PageNavigation_utils_checkIsTruncated(textRef));
  }, []);
  const InnerContent = ({ hover, selected }) => {
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    const textType = selected ? "Body3" : "Body2";
    return React__default.default.createElement(
      "div",
      { className: styles.rowContainer, "data-zds": true },
      React__default.default.createElement(
        "span",
        { className: styles.textWrap, "data-zds": true },
        React__default.default.createElement(
          "span",
          { className: styles.textEllipsis, style: { "--_zds-nestedsecondrow-text-color": theme_Colors.Colors[textColor] }, ref: textRef, "data-zds": true },
          React__default.default.createElement(components_display_Text_Text.Text, { color: textColor, margin: "0 0 0 8px", type: textType }, item.title)
        )
      ),
      item.count && React__default.default.createElement(components_navigation_PageNavigation_PageNavigationBadge, { variant: "neutral" }, item.count.toString())
    );
  };
  const Content = ({ hover, selected }) => isTruncated ? React__default.default.createElement(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: item.title, isBlock: true, position: "northeast" }, () => React__default.default.createElement(InnerContent, { hover, selected })) : React__default.default.createElement(InnerContent, { hover, selected });
  const NestedList = React.useMemo(() => item.children ? () => {
    var _a;
    return React__default.default.createElement("ul", { className: styles.list, "data-zds": true }, (_a = item.children) === null || _a === void 0 ? void 0 : _a.map((i) => React__default.default.createElement(components_navigation_PageNavigation_NestedThirdRow, { item: i, key: i.id, onSelect })));
  } : void 0, [item, onSelect]);
  return React__default.default.createElement(components_navigation_PageNavigation_PageNavigationRow, { content: Content, item, nestedList: NestedList, onSelect });
}

module.exports = NestedSecondRow;
//# sourceMappingURL=NestedSecondRow.cjs.js.map
